<template>
  <div>
    <a @click="toggleShow">{{ $t('cha-kan-xiang-qing') }}</a>
    <a-modal
      :open="visible"
      wrapClassName="xmov-normal-modal"
      centered
      width="900px"
      :footer="null"
      :title="$t('yun-cun-chu-kong-jian-xiang-qing')"
      @cancel="visible = false"
    >
      <a-table
        class="xmov-table-pagination"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        :scroll="{ y: '525px' }"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'start_timestamp'">
            {{ text ? timezoneFormat(text, 'YYYY-MM-DD HH:mm:ss') : '' }}
          </template>
          <template v-if="column.dataIndex === 'total_storage'">
            {{ getFormateFileSize(record?.rights?.total_storage) }}
          </template>
          <template v-if="column.dataIndex === 'expired_timestamp'">
            {{
              text
                ? timezoneFormat(text, 'YYYY-MM-DD HH:mm:ss')
                : $t('yong-jiu-you-xiao')
            }}
          </template>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import type { TableProps } from 'ant-design-vue'
import type { ColumnsType } from 'ant-design-vue/es/table/interface'
import { reqCreditCoinOrder } from '~/api'
import { usePage } from '~/hooks/usePage'
import { useTime } from '~/hooks/useTime'

const visible = ref(false)

const { timezoneFormat } = useTime()

const { $t } = useNuxtApp()

const columns: ColumnsType = [
  {
    title: $t('yun-cun-chu-kong-jian-lei-xing'),
    width: 200,
    dataIndex: 'rights_name',
  },
  {
    title: $t('he-ji'),
    width: 100,
    dataIndex: 'total_storage',
  },
  {
    title: $t('sheng-xiao-shi-jian'),
    width: 180,
    dataIndex: 'start_timestamp',
  },
  {
    title: $t('shi-xiao-shi-jian'),
    width: 180,
    dataIndex: 'expired_timestamp',
  },
]

const { list, total, page, page_size, loading, getList, reload } = usePage({
  api: async (params) => {
    const res = await reqCreditCoinOrder({
      ...params,
      check_all: 0,
      many: 1,
      order_type__in: '2,99',
    })
    return {
      ...res,
      data: {
        // 存储要显示，言币不显示
        // 原本的逻辑是过滤掉 is_show, 现在改成不过滤
        // is_show 是用于后端判断是否要进入计算
        order_list: res.data?.order_list || [],
      },
    }
  },
  pageSize: 10,
})

const pagination = computed<any>(() => ({
  total: total.value,
  current: page.value,
  pageSize: page_size.value,
  showTotal: (total: string) => $t('gong-total-tiao', [total]),
  showSizeChanger: true,
  showQuickJumper: true,
}))

const handleTableChange: TableProps['onChange'] = (p) => {
  page.value = p.current as number
  page_size.value = p.pageSize as number
  getList({ page: p.current, page_size: p.pageSize })
}

const toggleShow = () => {
  if (!visible.value && !list.value.length) {
    getList()
  }
  visible.value = !visible.value
}
</script>
